import React, { useState } from 'react';
import { Check, ChevronRight, Star, Camera, Video, MessageCircle, Image as ImageIcon, Sparkles } from 'lucide-react';
import { AngelData } from './UnleashWizard';
import { PhotoRatingFlow } from '../PhotoRatingFlow';
interface AngelCreatedSuccessProps {
  angel: AngelData;
  onContinue: () => void;
}
export const AngelCreatedSuccess: React.FC<AngelCreatedSuccessProps> = ({
  angel,
  onContinue
}) => {
  const [showPhotoRatingFlow, setShowPhotoRatingFlow] = useState(false);
  const handlePhotoRatingClick = () => {
    setShowPhotoRatingFlow(true);
  };
  return <div className="w-full max-w-md mx-auto bg-white dark:bg-gray-900 rounded-xl shadow-lg overflow-hidden" data-id="element-21761">
      <div className="p-6 bg-gradient-to-r from-pink-600 to-purple-600 text-white" data-id="element-21762">
        <div className="w-20 h-20 bg-white/20 rounded-full mx-auto flex items-center justify-center" data-id="element-21763">
          <Check size={40} className="text-white" data-id="element-21764" />
        </div>
        <h1 className="text-2xl font-bold text-center mt-4" data-id="element-21765">
          Angel Unleashed!
        </h1>
        <p className="text-pink-100 text-center mt-2" data-id="element-21766">
          {angel.name} is now ready to join your world
        </p>
      </div>
      <div className="p-6" data-id="element-21767">
        <div className="flex items-center justify-center mb-6" data-id="element-21768">
          <div className="w-24 h-24 bg-gradient-to-r from-pink-400 to-purple-500 rounded-full flex items-center justify-center text-white text-5xl" data-id="element-21769">
            👩
          </div>
        </div>
        <div className="space-y-4" data-id="element-21770">
          <div className="flex items-center justify-between py-2 border-b border-gray-200 dark:border-gray-800" data-id="element-21771">
            <span className="text-gray-600 dark:text-gray-400" data-id="element-21772">Name</span>
            <span className="font-medium" data-id="element-21773">{angel.name}</span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-200 dark:border-gray-800" data-id="element-21774">
            <span className="text-gray-600 dark:text-gray-400" data-id="element-21775">
              Personality
            </span>
            <span className="font-medium capitalize" data-id="element-21776">
              {angel.personality.replace('_', ' ')}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-200 dark:border-gray-800" data-id="element-21777">
            <span className="text-gray-600 dark:text-gray-400" data-id="element-21778">
              Relationship
            </span>
            <span className="font-medium capitalize" data-id="element-21779">
              {angel.relationship.replace('_', ' ')}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-200 dark:border-gray-800" data-id="element-21780">
            <span className="text-gray-600 dark:text-gray-400" data-id="element-21781">Job</span>
            <span className="font-medium capitalize" data-id="element-21782">
              {angel.job.replace('_', ' ')}
            </span>
          </div>
          <div className="flex items-center justify-between py-2 border-b border-gray-200 dark:border-gray-800" data-id="element-21783">
            <span className="text-gray-600 dark:text-gray-400" data-id="element-21784">Hobby</span>
            <span className="font-medium capitalize" data-id="element-21785">
              {angel.hobby.replace('_', ' ')}
            </span>
          </div>
        </div>
        <div className="mt-8 p-4 bg-pink-50 dark:bg-pink-900/20 rounded-lg border border-pink-200 dark:border-pink-800/30" data-id="element-21786">
          <div className="flex items-center" data-id="element-21787">
            <div className="w-10 h-10 rounded-full bg-pink-500/20 flex items-center justify-center text-pink-500 mr-4" data-id="element-21788">
              <Star size={20} data-id="element-21789" />
            </div>
            <div data-id="element-21790">
              <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-21791">
                You've earned 250 XP!
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-21792">
                Creating your first Angel is a big step
              </p>
            </div>
          </div>
        </div>
        <div className="mt-6 flex flex-col space-y-3" data-id="element-21793">
          <button onClick={() => {
          // Navigate to the AllAngelsGrid
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'all_angels'
            }
          });
          document.dispatchEvent(navigateEvent);
        }} className="w-full py-3 rounded-lg font-medium text-white bg-gradient-to-r from-pink-500 to-purple-600 hover:shadow-lg hover:shadow-pink-500/30 transition-all" data-id="element-21794">
            Visit Angel Feed
          </button>
          <button onClick={() => {
          // Navigate to chat with this angel
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'chat'
            }
          });
          document.dispatchEvent(navigateEvent);
          // Set angel as active chat partner
          const selectAngelEvent = new CustomEvent('selectAngel', {
            detail: {
              angelId: angel.id || '1' // Default to ID 1 if not available
            }
          });
          document.dispatchEvent(selectAngelEvent);
        }} className="w-full py-3 rounded-lg font-medium text-white bg-gradient-to-r from-blue-500 to-teal-600 hover:shadow-lg hover:shadow-blue-500/30 transition-all flex items-center justify-center" data-id="element-21795">
            <MessageCircle size={16} className="mr-2" data-id="element-21796" />
            <span data-id="element-21797">Chat with {angel.name}</span>
          </button>
          <button onClick={() => {
          // Show modal for generating image/video
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'twitter_profile'
            }
          });
          document.dispatchEvent(navigateEvent);
          // Set this angel as selected
          const selectAngelEvent = new CustomEvent('selectAngel', {
            detail: {
              angelId: angel.id || '1' // Default to ID 1 if not available
            }
          });
          document.dispatchEvent(selectAngelEvent);
        }} className="w-full py-3 rounded-lg font-medium text-white bg-gradient-to-r from-indigo-500 to-blue-600 hover:shadow-lg hover:shadow-indigo-500/30 transition-all flex items-center justify-center" data-id="element-21798">
            <div className="flex items-center" data-id="element-21799">
              <ImageIcon size={16} className="mr-1" data-id="element-21800" />
              <span className="mx-0.5" data-id="element-21801">/</span>
              <Video size={16} className="ml-1 mr-2" data-id="element-21802" />
            </div>
            <span data-id="element-21803">Generate Image / Video</span>
          </button>
          <button onClick={handlePhotoRatingClick} className="w-full py-3 rounded-lg font-medium text-white bg-gradient-to-r from-purple-500 to-pink-600 hover:shadow-lg hover:shadow-purple-500/30 transition-all flex items-center justify-center" data-id="element-21804">
            <Camera size={16} className="mr-2" data-id="element-21805" />
            <span data-id="element-21806">Let {angel.name} review your dickpic</span>
          </button>
          {/* New button for creating a scenario with the angel */}
          <button onClick={() => {
          // First, navigate to the Unleash feature and store the angel name in localStorage
          // This will ensure the data persists across navigation
          localStorage.setItem('pendingScenarioAngel', angel.name);
          console.log(`Storing angel name in localStorage: ${angel.name}`);
          // Navigate to the unleash section
          console.log(`Navigating to unleash section for angel: ${angel.name}`);
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'unleash'
            }
          });
          document.dispatchEvent(navigateEvent);
          // Use a more aggressive approach with multiple timeouts at different intervals
          // to ensure the event is captured at some point after navigation
          const timeouts = [800, 1200, 1600, 2000];
          timeouts.forEach(timeout => {
            setTimeout(() => {
              console.log(`Attempting to set scenario feature at ${timeout}ms for angel: ${angel.name}`);
              const setFeatureEvent = new CustomEvent('setUnleashFeature', {
                detail: {
                  feature: 'scenario',
                  angelName: angel.name
                }
              });
              document.dispatchEvent(setFeatureEvent);
            }, timeout);
          });
        }} className="w-full py-3 rounded-lg font-medium text-white bg-gradient-to-r from-amber-500 to-orange-600 hover:shadow-lg hover:shadow-amber-500/30 transition-all flex items-center justify-center" data-id="element-21807">
            <Sparkles size={16} className="mr-2" data-id="element-21808" />
            <span data-id="element-21809">Unleash a scenario with {angel.name}</span>
          </button>
          <button onClick={() => {
          // Navigate to the RewardsSection
          const navigateEvent = new CustomEvent('navigate', {
            detail: {
              section: 'rewards'
            }
          });
          document.dispatchEvent(navigateEvent);
        }} className="w-full py-3 rounded-lg font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center justify-center" data-id="element-21810">
            <span data-id="element-21811">View Rewards</span>
            <ChevronRight size={16} className="ml-1" data-id="element-21812" />
          </button>
        </div>
      </div>
      {/* PhotoRatingFlow Modal */}
      {showPhotoRatingFlow && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-21813">
          <PhotoRatingFlow onClose={() => setShowPhotoRatingFlow(false)} data-id="element-21814" />
        </div>}
    </div>;
};